import React from 'react'
import { Link, Outlet, useParams } from 'react-router-dom'
import { useProjects } from '../contexts/ProjectsContext'
import PageLoader from '../components/ui/PageLoader'
import Button from '../components/ui/Button'

export default function MechanicalTestsShell() {
  const { id } = useParams()
  const { getProject, loading } = useProjects()
  const project = id ? getProject(id) : undefined

  if (!id) {
    return <p className="px-4 text-sm text-gray-500">Missing project id.</p>
  }

  // Only block the shell on cold load. Background hub refresh must keep
  // <Outlet /> mounted or Upload queue state (File blobs) is wiped.
  if (loading && !project) {
    return <PageLoader label="Loading project…" />
  }

  if (!project) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-6 text-sm text-gray-600">
        <p className="font-medium text-gray-900">Project not found</p>
        <Link to="/resources" className="mt-4 inline-block">
          <Button type="button">Go to Project Hub</Button>
        </Link>
      </div>
    )
  }

  return (
    <div className="flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-page-bg">
      <Outlet />
    </div>
  )
}
